import { boolean, string } from "yup";
import { LoginRegisterText } from "../LoginRegister-types";
import { emailValidationSchema } from "../../Shared/utils/formValidation";
//TODO: Export from shared instead of repeating?
/**
 * Func to provide error messages with field names (where possible).
 * @param fieldName
 * @returns String error message. E.g., "First Name field is required."
 */
const errMsg = (fieldName) => `${fieldName} is required.`;
export const loginFormSchema = {
    email: emailValidationSchema,
    password: string().required(errMsg(LoginRegisterText.PASSWORD)),
    rememberMe: boolean().notRequired(),
};
